import { useMemo } from 'react';
import { useExperimentGroupValue } from 'shared/src/context/UserContext/useExperimentGroup';

export type ProductOptionMaxDiscountMode = 'disabled' | 'variantB' | 'variantC';

export const useProductOptionMaxDiscountMode = ({
  enabled = true,
}: {
  enabled?: boolean;
} = {}): ProductOptionMaxDiscountMode => {
  const expGroup = useExperimentGroupValue({ sno: 'EXP1710' });

  return useMemo<ProductOptionMaxDiscountMode>(() => {
    if (!enabled) return 'disabled';
    if (expGroup === 'C') return 'variantC';
    if (expGroup === 'B') return 'variantB';
    return 'disabled';
  }, [enabled, expGroup]);
};
